export function isNestedWindow() {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}
